import { render, staticRenderFns } from "./TextHero.vue?vue&type=template&id=722e2169&scoped=true&"
import script from "./TextHero.vue?vue&type=script&lang=js&"
export * from "./TextHero.vue?vue&type=script&lang=js&"
import style0 from "./TextHero.vue?vue&type=style&index=0&id=722e2169&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722e2169",
  null
  
)

export default component.exports